import { useEffect } from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const BoListContent = ({ data, boName }) => {

    useEffect(() => {
        const labels = [
            "ID",
            "Data/hora",
            "Dia da semana",
            `Status dos ${boName}`,
            "Flagrante",
            "Natureza",
            "Grupo de natureza",
            "Endereço",
            "Bairro",
            "Apreensões",
            "Veículos",
            "Indivíduos",
            "Condições dos indivíduos",
            "Encaminhamento de indivíduos"
        ];

        const values = data.boList.map(element => [
            element.id,
            ReportUtils.formatDateTimeLabel(element.date_time),
            element.dow,
            element.status,
            element.flagrant ? "Sim" : "Não",
            element.reasons,
            element.group_reason,
            element.address,
            element.neighborhood,
            element.apprehensions_qty,
            element.vehicles_qty,
            element.individuals_qty,
            element.ind_conditions,
            element.ind_referral
        ]);

        ReportUtils.createExportableTable(labels, values, "Informações gerais");

    }, [data]);

    return null;
};

export default BoListContent;